import React, { useState } from 'react'
import { MySwal } from '../../../library/swal';
import axios from "../../../library/axios"
import Button from 'react-bootstrap/Button'
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import { getApiErrorMessage } from '../../../helpers/apiErrorMessage';

const EditChatComp = (props) => {

    // console.log(props)

    const [chat, setChat] = useState(props.chat.text)

    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)

    const handleUpdateChat = (idForum) => {
        setLoading(true)
        setDisabled(true)

        const requestBody = {
            idForum: props.chat.idForum,
            text: chat,
        }
        // console.log(requestBody)
        // return false
        axios({
            url: `/forum-chat/update-chat/${props.chat.id}`,
            method: 'PATCH',
            data: requestBody,
            headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
        })
            .then(res => {
                // console.log(res)
                // return false
                if (res.status === 200) {
                    MySwal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Berhasil merubah diskusi!'
                    })

                    setLoading(false)
                    setDisabled(false)

                    props.fetch()
                    props.close()
                }
            })
            .catch(err => {
                setLoading(false)
                setDisabled(false)
                if (err !== "") {
                    console.log(err?.response)
                    MySwal.fire({
                        icon: 'error',
                        title: 'Oops, Error!',
                        text: getApiErrorMessage(err)
                    })
                }
            })

    }

    return (
        <>
            <div className="mb-3 row">
                <label htmlFor="Chat" className="col-sm-12 col-form-label required">Komentar</label>
                <div className="col-12">
                    <textarea className='form-control' id='Chat' onChange={(e) => setChat(e.target.value)} value={chat} rows={3}></textarea>
                </div>
            </div>

            <div className="mt-5 row">
                <div className="col-12">
                    <Button variant="danger" size="sm" onClick={() => props.close()}>
                        Tutup
                    </Button>
                    &nbsp;
                    <Button disabled={disabled} variant="success" size="sm" onClick={() => handleUpdateChat()}>{loading === true ? 'Mohon Tunggu..' : 'Simpan'}</Button>
                </div>
            </div>
        </>
    )
}

export default EditChatComp
